const office = {
  icon: 'HomeIcon',
  title: 'Office Management',
  subtitle: 'Manage offices, banking details, and currency conversions. ',
  refresh: true,
  refreshLabel: 'Refresh',
}

export default office
